import { connect } from 'react-redux';

import { OBJECT_TYPE_SEGMENTS } from '@iconik-io/iconik-api/src/types/object_types';

import { deleteSegment } from '../../../ducks/asset_time_based_metadata/thunks';
import type { AppState } from '../../../store/types';
import DeleteObjectsModal from './delete_objects';

const DeleteTimeBasedMetadata = connect(
  (state: AppState) => ({
    objectType: OBJECT_TYPE_SEGMENTS,
    entity: state.pages.asset.asset.id,
  }),
  {
    deleteEntityByIds: (ids: string[], entity?: string) =>
      deleteSegment(entity ?? '', ids[0]),
  },
)(DeleteObjectsModal);

export default DeleteTimeBasedMetadata;
